export interface IBlobSasModel {
  modelId: number;
  modelTypeName: string;
  fileName: string;
  container: string;
  sasUrl: string;
  sasToken: string;
  issueDate: string;
}

export class BlobSasModel implements IBlobSasModel {
  modelId: number;
  modelTypeName: string;
  fileName: string;
  container: string;
  sasUrl: string;
  sasToken: string;
  issueDate: string;

  constructor(params: Partial<IBlobSasModel> = {}) {
    const {
      modelId = 0,
      modelTypeName = '',
      fileName = '',
      container = '',
      sasUrl = '',
      sasToken = '',
      issueDate = '',
    } = params;

    this.modelId = modelId;
    this.modelTypeName = modelTypeName;
    this.fileName = fileName;
    this.container = container;
    this.sasUrl = sasUrl;
    this.sasToken = sasToken;
    this.issueDate = issueDate;
  }
}
